import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/SimulationTemplates?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getById(lifestyle_Question_ID, facilityId) {
		const url = lifestyle_Question_ID
			? `/api/Cms/SimulationTemplate?id=${lifestyle_Question_ID}&facilityId=${facilityId}`
			: `/api/Cms/SimulationTemplate?facilityId=${facilityId}`;

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(simulationTemplateData) {
		try {
			await axios.put(
				`${API_URL}/api/Cms/SimulationTemplate`,
				simulationTemplateData,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async deleteById(simulationTemplateId) {
		try {
			await axios.delete(
				`${API_URL}/api/Cms/SimulationTemplate?id=${simulationTemplateId}`,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
